'use client'

import Icon, { type IAvailableIcons } from '@/components/v2/ui/icon'
import { useTexts } from '@/contexts/LanguageContext'

function PrivacyCard({ icon, title, body }: { icon: IAvailableIcons; title: string; body: string }) {
  return (
    <div className="flex flex-col gap-1.5 rounded border border-trust-center-border p-4">
      <Icon icon={icon} className="size-4 text-trust-center-accent" />
      <span className="text-sm font-semibold">{title}</span>
      <span className="text-xs text-pretty text-trust-center-muted">{body}</span>
    </div>
  )
}

export default function PrivacyCards() {
  const { PRIVACY } = useTexts().PUBLIC_TRUST_CENTER.SUBPROCESSORS
  const cards: { icon: IAvailableIcons; title: string; body: string }[] = [
    { icon: 'map-pin', title: PRIVACY.RESIDENCY.TITLE, body: PRIVACY.RESIDENCY.BODY },
    { icon: 'timer', title: PRIVACY.RETENTION.TITLE, body: PRIVACY.RETENTION.BODY },
    { icon: 'user-round-check', title: PRIVACY.RIGHTS.TITLE, body: PRIVACY.RIGHTS.BODY },
    { icon: 'scale', title: PRIVACY.GDPR.TITLE, body: PRIVACY.GDPR.BODY },
  ]
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <PrivacyCard key={card.icon} icon={card.icon} title={card.title} body={card.body} />
      ))}
    </div>
  )
}
